<template>
  <div class="task-manager" ref="taskManagerRef">
    <div class="task-content" :style="{ transform: 'translateZ(0)' }">
      <div class="task-header">
        <h2>任务管理</h2>
        <div class="header-buttons">
          <a-button type="primary" @click="showAddTaskModal">新增任务</a-button>
          <a-button type="primary" @click="handleClose">返回</a-button>
        </div>
      </div>

      <div class="task-container">
        <div class="action-bar">
          <a-space>
            <a-button
              type="primary"
              :disabled="!selectedRowKeys.length"
              @click="() => handleExecute(selectedRowKeys)"
            >
              <template #icon><PlayCircleOutlined /></template>
              批量执行 ({{ selectedRowKeys.length }})
            </a-button>
            <a-button
              type="primary"
              danger
              :disabled="!selectedRowKeys.length"
              @click="handleBatchDelete"
              class="delete-btn"
            >
              <delete-outlined />批量删除 ({{ selectedRowKeys.length }})
            </a-button>
          </a-space>
        </div>

        <a-table
          :loading="loading"
          :columns="columns"
          :data-source="tasks"
          :row-selection="rowSelection"
          :pagination="{
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total) => `共 ${total} 条`,
            size: 'default',
          }"
          :scroll="{ x: '100%' }"
          row-key="id"
          bordered
          class="custom-table"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'action'">
              <a-space>
                <a-button
                  type="primary"
                  size="small"
                  v-show="false"
                  @click="handleViewLog(record.taskId)"
                >
                  <template #icon><FileTextOutlined /></template>
                  查看日志
                </a-button>
              </a-space>
            </template>
            <template v-else-if="column.key === 'statuss'">
              <a-tag :color="getStatusColor(record.statuss)">
                {{ getStatusText(record.statuss) }}
              </a-tag>
            </template>
          </template>
        </a-table>
      </div>

      <a-modal
        v-model:visible="addTaskModalVisible"
        title="新增任务"
        @ok="handleAddTask"
        @cancel="handleAddTaskCancel"
        :confirmLoading="confirmLoading"
        okText="增加"
        cancelText="取消"
        width="900px"
      >

      <template #footer>
        <a-button key="back" @click="handleAddTaskCancel">取消</a-button>
        <a-button key="submit" type="primary"  @click="handleAddTask">增加(账号)</a-button>
        <a-button key="submit" type="primary"  @click="handleAddTaskID">增加(ID)</a-button>
      </template>

        <div class="task-form-container">
          <!-- 左侧基本信息 -->
          <div class="form-left">
            <a-form
              ref="addTaskFormRef"
              :model="taskForm"
              :rules="rules"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 16 }"
            >
              <a-form-item label="发送者" name="phone">
                <a-select
                  v-model:value="taskForm.phone"
                  mode="multiple"
                  placeholder="请选择发送者"
                  @change="handlePhoneChange"
                  :options="phoneOptions"
                />
              </a-form-item>

              <a-form-item label="发送内容" name="message">
                <!-- 添加工具栏 -->
                <div class="format-toolbar">
                  <a-button-group>
                    <a-button @click="formatText.bold" title="粗体">B</a-button>
                    <a-button @click="formatText.italic" title="斜体">I</a-button>
                    <a-button @click="formatText.underline" title="下划线">U</a-button>
                    <a-button @click="formatText.strikethrough" title="删除线">S</a-button>
                    <a-button @click="formatText.code" title="行内代码">{}</a-button>
                    <a-button @click="formatText.codeblock" title="代码块">{ }</a-button>
                    <a-button @click="formatText.link" title="添加链接">🔗</a-button>
                    <a-button @click="formatText.spoiler" title="隐藏文本">⊟</a-button>
                    <a-button @click="formatText.quote" title="引用">"</a-button>
                  </a-button-group>
                </div>
                <a-textarea
                  v-model:value="taskForm.message"
                  placeholder="请输入发送内容"
                  :rows="4"
                />
              </a-form-item>

              <a-form-item label="开始时间" name="startTime">
                <a-date-picker
                  v-model:value="taskForm.startTime"
                  :show-time="true"
                  format="YYYY-MM-DD HH:mm:ss"
                  placeholder="选择开始时间"
                  style="width: 100%"
                />
              </a-form-item>

              <a-form-item label="结束时间" name="endTime">
                <a-date-picker
                  v-model:value="taskForm.endTime"
                  :show-time="true"
                  format="YYYY-MM-DD HH:mm:ss"
                  placeholder="选择结束时间"
                  style="width: 100%"
                />
              </a-form-item>

              <a-form-item label="间隔时间(秒)" name="interval">
                <a-input-number
                  v-model:value="taskForm.interval"
                  :min="5"
                  placeholder="请输入间隔时间"
                  style="width: 100%"
                />
              </a-form-item>

              <a-form-item label="发送类型" name="type">
                <a-select
                  v-model:value="taskForm.type"
                  placeholder="请选择发送类型"
                >
                  <a-select-option :value="1">普通发送</a-select-option>
                  <a-select-option :value="2">POSTMAN发送</a-select-option>
                </a-select>
              </a-form-item>
            </a-form>
          </div>

          <!-- 右侧接收者选择1 -->
          <div class="form-right">
            <a-form-item
              label="接收者(账号)"
              name="targets"
              class="targets-form-item"
            >
              <div class="targets-container">
                <div class="targets-header">
                  <div class="search-row">
                    <a-input-search
                      v-model:value="searchText"
                      placeholder="搜索接收者"
                      @search="onSearch"
                      style="width: 100%"
                    />
                  </div>
                  <div class="targets-actions">
                    <div class="batch-select">
                      <!-- <a-button size="small" @click="handleBatchSelect(100)"
                        >选择100条</a-button
                      > -->
                      <a-button size="small" @click="handleBatchSelect()"
                        >全选</a-button
                      >
                      <a-button size="small" @click="handleClearSelection"
                        >清空</a-button
                      >
                    </div>
                    <div class="targets-count">
                      已选择: {{ taskForm.targets.length }} 个接收者
                    </div>
                  </div>
                </div>
                <div class="targets-list">
                  <a-checkbox-group
                    v-model:value="taskForm.targets"
                    class="targets-checkbox-group"
                  >
                    <a-checkbox
                      v-for="target in filteredTargets"
                      :key="target.id"
                      :value="target.name"
                      class="target-item"
                    >
                      <div class="target-info">
                        <span class="target-name">{{ target.name }}</span>
                        <span class="target-nickname" v-if="target.nickname">
                          ({{ target.nickname }})
                        </span>
                      </div>
                    </a-checkbox>
                  </a-checkbox-group>
                </div>
              </div>
            </a-form-item>
            <!-- 接收者(ID) -->
            <a-form-item
              label="接收者(ID)"
              name="targets"
              class="targets-form-item"
            >
              <div class="targets-container">
                <div class="targets-header">
                  <div class="search-row">
                    <a-input-search
                      v-model:value="searchId"
                      placeholder="搜索接收者"
                      @search="onSearchID"
                      style="width: 100%"
                    />
                  </div>
                  <div class="targets-actions">
                    <div class="batch-select">
                      <!-- <a-button size="small" @click="handleBatchSelect(100)"
                        >选择100条</a-button
                      > -->
                      <a-button size="small" @click="handleBatchSelectId()"
                        >全选</a-button
                      >
                      <a-button size="small" @click="handleClearSelectionId"
                        >清空</a-button
                      >
                    </div>
                    <div class="targets-count">
                      已选择: {{ taskForm.targetIds.length }} 个接收者
                    </div>
                  </div>
                </div>
                <div class="targets-list">
                  <a-checkbox-group
                    v-model:value="taskForm.targetIds"
                    class="targets-checkbox-group"
                  >
                    <a-checkbox
                      v-for="target in filteredTargetIds"
                      :key="target.id"
                      :value="target.name"
                      class="target-item"
                    >
                      <div class="target-info">
                        <span class="target-name">{{ target.name }}</span>
                        <span class="target-nickname" v-if="target.nickname">
                          ({{ target.nickname }})
                        </span>
                      </div>
                    </a-checkbox>
                  </a-checkbox-group>
                </div>
              </div>
            </a-form-item>


          </div>


        </div>
      </a-modal>

      <a-modal
        v-model:visible="logModalVisible"
        title="任务日志"
        :footer="null"
        width="800px"
      >
        <div class="mb-4">任务ID: {{ currentTaskId }}</div>
        <a-table
          :columns="columns"
          :data-source="logData"
          :pagination="false"
          bordered
        />
      </a-modal>

      <!-- 添加链接编辑对话框 -->
      <a-modal
        v-model:visible="linkModalVisible"
        title="添加链接"
        @ok="handleLinkConfirm"
        okText="确定"
        cancelText="取消"
      >
        <a-form :model="linkForm" layout="vertical">
          <a-form-item label="链接文字">
            <a-input v-model:value="linkForm.text" placeholder="请输入链接显示的文字" />
          </a-form-item>
          <a-form-item label="链接地址">
            <a-input v-model:value="linkForm.url" placeholder="请输入链接地址" />
          </a-form-item>
        </a-form>
      </a-modal>
    </div>
  </div>

    <!-- 添加任务管理模态框 -->
    <div v-if="taskDetailManagerVisible" class="task-manager-container">
      <TaskDetailManager v-model:visible="taskDetailManagerVisible" />
    </div>

</template>

<script setup lang="ts">
import {
  ref,
  computed,
  watch,
  onMounted,
  nextTick,
  onBeforeUnmount,
  h,
  reactive,
} from "vue";
import { useRoute } from "vue-router";
import { message, Modal, Table } from "ant-design-vue";
import type { FormInstance, TableColumnType } from "ant-design-vue";
import {
  DeleteOutlined,
  PlayCircleOutlined,
  FileTextOutlined,
} from "@ant-design/icons-vue";
import { TelegramClient } from "@/websocket/Client";
import TaskDetailManager from "./TaskDetailManager.vue"; // 导入任务管理组件
const taskDetailManagerVisible = ref(false);
const client = TelegramClient.getInstance();
const account = localStorage.getItem("username") || "";

// 定义日志数据的接口
interface LogItem {
  taskId: number;
  receiver: string;
  sendTime: string;
  errorMsg: string;
  phone: string;
}

// 表格列定义
const columns: TableColumnType[] = [
  {
    title: "任务ID",
    dataIndex: "id",
    key: "id",
    width: 80,
    align: "center",
  },
  {
    title: "任务类型",
    dataIndex: "task_type",
    key: "id",
    width: 80,
    align: "center",
    customRender: ({ text }) => {      
      const typeNum = Number(text);
      switch (typeNum) {
        case 1:
          return "账号发送";
        case 2:
          return "数字ID发送";
        default:
          return `未知类型(${text})`;
      }
    },
  },
  {
    title: "状态",
    dataIndex: "statuss",
    key: "statuss",
    width: 100,
    align: "center",
  },
  {
    title: "发送内容",
    dataIndex: "message",
    key: "message",
    ellipsis: true,
    width: 200,
  },
  {
    title: "发送者",
    dataIndex: "phone",
    key: "phone",
    width: 120,
    align: "center",
  },
  // {
  //   title: "开始时间",
  //   dataIndex: "start_time",
  //   key: "start_time",
  //   width: 160,
  //   align: "center",
  //   customRender: ({ text }) => {
  //     return text ? new Date(text * 1000).toLocaleString() : "-";
  //   },
  // },
  // {
  //   title: "结束时间",
  //   dataIndex: "end_time",
  //   key: "end_time",
  //   width: 160,
  //   align: "center",
  //   customRender: ({ text }) => {
  //     return text ? new Date(text * 1000).toLocaleString() : "-";
  //   },
  // },
  {
    title: "任务间隔(秒)",
    dataIndex: "interval",
    key: "interval",
    width: 120,
    align: "center",
  },
  {
    title: "发送类型",
    dataIndex: "type",
    key: "type",
    width: 120,
    align: "center",
    customRender: ({ text }) => {      
      const typeNum = Number(text);
      switch (typeNum) {
        case 1:
          return "普通发送";
        case 2:
          return "POSTMAN发送";
        default:
          return `未知类型(${text})`;
      }
    },
  },
  {
    title: "操作",
    key: "action",
    fixed: "right",
    width: 180,
    align: "center",
  },
];

// 数据相关
const visible = ref(true);
const loading = ref(false);
const tasks = ref<any[]>([]);
const selectedRowKeys = ref<number[]>([]);
const modalVisible = ref(false);
const confirmLoading = ref(false);
const formRef = ref<FormInstance>();

// 表单相关
const taskForm = ref<{
  phone: string[];
  message: string;
  targets: string[];
  targetIds: string[];
  startTime: Date | null;
  endTime: Date | null;
  interval: number | null;
  type: number;
}>({
  phone: [],
  message: "",
  targets: [],
  targetIds: [],
  startTime: null,
  endTime: null,
  interval: null,
  type: 1,
});

// 添加新的 ref 用于存储发送者列表
const phoneList = ref<string[]>([]);

// 获取发送者列表
const fetchPhoneList = async () => {
  try {
    const response = await client.getAccountList(account);
    if (response && response.list) {
      //console.log("获取发送者列表", response);
      phoneList.value = response.list.map((item: any) => item.strAccount);
    }
  } catch (error) {
    message.error("获取发送者列表失败");
  }
};

// 添加新的 ref 用于存储接收者列表
const targetsList = ref<any[]>([]);

const targetIdsList = ref<any[]>([]);

const rules = {
  phone: [{ required: true, message: "请输入发送者", trigger: "blur" }],
  message: [{ required: true, message: "请输入发送内容", trigger: "blur" }],
  targets: [{ required: true, message: "请选择接收者", trigger: "change" }],
  interval: [{ required: true, message: "请输入间隔时间", trigger: "change" }],
  type: [{ required: true, message: "请选择任务类型", trigger: "change" }],
};

// 接收父组件传入的 visible prop
const props = defineProps<{
  visible: boolean;
}>();

const emit = defineEmits<{
  (e: "update:visible", visible: boolean): void;
}>();

// 使用计算属性处理 visible 状态
const isOpen = computed({
  get: () => props.visible,
  set: (value) => emit("update:visible", value),
});

// 监听可见性变化
watch(
  () => props.visible,
  (newVisible) => {
    if (newVisible) {
      console.log("任务管理页面显示，获取任务列表");
      fetchTasks();
    }
  }
);

// 处理关闭
const handleClose = () => {
  emit("update:visible", false);
};

// 获取任务列表
const fetchTasks = async () => {
  try {
    loading.value = true;
    const response = await client.getTaskList(account);
    console.log("获取任务列表", response);

    // 修改这部分逻辑，确保在没有数据时将任务列表清空
    if (response && response.list) {
      tasks.value = response.list.map((item) => ({
        id: item.index,
        statuss: item.status,
        message: item.message,
        task_type: item.task_type,
        type: item.msg_type,
        start_time: item.start_time,
        end_time: item.end_time,
        interval: item.interval,
        created_at: item.create_time,
        taskId: item.index,
        phone: item.phone,
        targets: item.targets,
      }));
    } else {
      // 如果response为undefined或没有list属性，将任务列表清空
      tasks.value = [];
    }
  } catch (error) {
    message.error("获取任务列表失败");
    // 发生错误时也清空任务列表
    tasks.value = [];
  } finally {
    loading.value = false;
  }
};

// 删除任务
const handleDelete = async (taskId: number) => {
  Modal.confirm({
    title: "确认删除",
    content: "确定要删除该任务吗？",
    async onOk() {
      try {
        const response = await client.deleteTask(account, [taskId]);
        if (response.code === 1) {
          message.success(response.reason);
          fetchTasks();
        } else {
          message.error(response.reason || "删除失败");
        }
      } catch (error) {
        message.error("删除失败");
      }
    },
  });
};

// 定义 rowSelection 为计算属性以确保响应性
const rowSelection = computed(() => ({
  selectedRowKeys: selectedRowKeys.value,
  onChange: (selectedKeys: number[]) => {
    selectedRowKeys.value = selectedKeys;
  },
  onSelect: (record: any, selected: boolean) => {
    console.log("选择单行:", record, selected);
  },
  onSelectAll: (selected: boolean, selectedRows: any[], changeRows: any[]) => {
    console.log("全选切换:", selected, selectedRows.length);
  },
}));

// 批量删除方法
const handleBatchDelete = async () => {
  if (!selectedRowKeys.value.length) return;

  Modal.confirm({
    title: "确认删除",
    content: `是否确认删除选中的 ${selectedRowKeys.value.length} 条记录？`,
    async onOk() {
      try {
        // 调用 client.deleteTask 方法删除选中的任务
        const response = await client.deleteTask(
          account,
          selectedRowKeys.value
        );
        if (response.code === 1) {
          message.success(response.reason || "删除成功");
          // 刷新列表
          await fetchTasks();
          // 清空选择
          selectedRowKeys.value = [];

        } else {
          message.error(response.reason || "删除失败");
        }
      } catch (error) {
        console.error("批量删除失败:", error);
        message.error("删除失败");
      }
    },
  });
};


// 显示任务模态框方法
const showTaskDetailModal = () => {
  taskDetailManagerVisible.value = true;
};

// 修改执行任务的处理函数
const handleExecute = async (taskIds: number[]) => {
  showTaskDetailModal();
  try {
    const response = await client.executeTask(account, taskIds);
    console.log(response);
    if (response.code === 1) {
      console.log(response.reason);
      message.success(response.reason || "任务执行成功");
      fetchTasks();
      // 清空选择
      selectedRowKeys.value = [];
    } else {
      console.log(response.reason);
      message.error(response.reason || "任务执行失败");
    }
  } catch (error) {
    message.error("任务执行失败");
  }
};

// 添加响应式变量
const logModalVisible = ref(false);
const logData = ref<any[]>([]);
const currentTaskId = ref<number>();

const handleViewLog = async (taskId: number) => {
  try {
    const response = await client.getTaskLog(account, [taskId]);
    console.log("获取任务日志", response);
    if (response.code === 1) {
      Modal.info({
        title: '任务日志',
        width: 1000,
        content: h('div', 
          { 
            style: 'max-height: 500px; overflow-y: auto;'
          },
          [
            // 表头
            h('div', 
              { 
                style: 'display: grid; grid-template-columns: repeat(4, 1fr); padding: 8px; background-color: #f5f5f5; font-weight: bold; text-align: center; border-bottom: 1px solid #e8e8e8;'
              },
              [
                h('div', null, '接收者'),
                h('div', null, '发送时间'),
                h('div', null, '状态'),
                h('div', null, '手机号'),
              ]
            ),
            // 数据行
            ...response.list.map((item, index) => 
              h('div', 
                { 
                  key: index,
                  style: 'display: grid; grid-template-columns: repeat(4, 1fr); padding: 8px; text-align: center; border-bottom: 1px solid #e8e8e8;'
                },
                [
                  h('div', null, item.receiver),
                  h('div', null, new Date(Number(item.sendTime) * 1000).toLocaleString()),
                  h('div', null, [
                    h('span', 
                      { 
                        style: `color: ${item.errorMsg === '发送成功' ? '#52c41a' : '#ff4d4f'}`
                      }, 
                      item.errorMsg
                    )
                  ]),
                  h('div', null, item.phone)
                ]
              )
            )
          ]
        ),
        okText: '关闭'
      });
    } else {
      message.error(response.reason || '获取日志失败');
    }
  } catch (error) {
    message.error('获取日志失败');
  }
};

const taskManagerRef = ref<HTMLElement | null>(null);
let resizeObserver: ResizeObserver | null = null;

// 防抖函数
const debounce = (fn: Function, delay: number) => {
  let timer: NodeJS.Timeout;
  return (...args: any[]) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
};

// 处理 ResizeObserver 的回调
const handleResize = debounce((entries: ResizeObserverEntry[]) => {
  for (const entry of entries) {
    // 只在真正需要处理尺寸变化时执行相关逻辑
    if (entry.target === taskManagerRef.value) {
      // 这里可以添加必要的尺寸调整逻辑
      console.debug("TaskManager size changed");
    }
  }
}, 100); // 100ms 的防抖延迟

onMounted(async () => {
  await nextTick();

  // 创建 ResizeObserver 实例
  resizeObserver = new ResizeObserver((entries) => {
    window.requestAnimationFrame(() => {
      handleResize(entries);
    });
  });

  // 只观察主容器元素
  if (taskManagerRef.value) {
    resizeObserver.observe(taskManagerRef.value);
  }

  // 错误处理
  const ignoreResizeObserverError = (error: ErrorEvent) => {
    if (error.message.includes("ResizeObserver")) {
      error.stopPropagation();
      return true;
    }
  };

  window.addEventListener("error", ignoreResizeObserverError);

  // 清理函数
  onBeforeUnmount(() => {
    window.removeEventListener("error", ignoreResizeObserverError);

    // 停止观察并断开连接
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
  });

  console.log("TaskManager组件已挂载");
  fetchTasks();
  fetchPhoneList();
});

// 添加新的 ref
const addTaskModalVisible = ref(false);
const addTaskFormRef = ref<FormInstance>();

// 显示新增任务弹窗
const showAddTaskModal = async () => {
  try {
    // 打开弹窗前获取接收者列表
    console.log("当前账号:", account);
    const response = await client.getPrivateChatList(account, "session", 2);
    console.log("获取接收者列表:", response);

    // 添加对空数据的处理
    if (response && Array.isArray(response) && response.length > 0) {
      targetsList.value = response.filter((value) => value.strAccount != "").map((receiver) => ({
        id: receiver.strTelegramNo,
        name: receiver.strAccount,
        nickname: receiver.strNickName,
      }));

      targetIdsList.value = response.filter((value) => value.strTelegramNo != "").map((receiver) => ({
        id: receiver.strTelegramNo,
        name: receiver.strTelegramNo,
        nickname: receiver.strNickName,
      }));
      console.log("111");
      let list =  targetIdsList.value;
      console.log("222");

    } else {
      // 确保targetsList为空数组而不是undefined
      targetsList.value = [];
      targetIdsList.value = [];
      message.warning("暂无可用的接收者列表");
    }

    // 无论是否有数据都显示弹窗
    addTaskModalVisible.value = true;
  } catch (error) {
    console.error("获取接收者列表出错:", error);
    message.error("获取接收者列表失败");
    // 发生错误时也确保targetsList为空数组
    targetsList.value = [];
    // 错误时仍然显示弹窗
    addTaskModalVisible.value = true;
  }
};

// 处理新增任务
const handleAddTask = async () => {
  console.log("handleAddTask");
  try {
    await addTaskFormRef.value?.validate();
    confirmLoading.value = true;

    // 直接使用选择的用户名，不需要再查找
    const targets = taskForm.value.targets.map(name => ({ name }));
 
    const taskData = {
      task_type:1,
      phones: taskForm.value.phone,
      targets: targets,
      msg_type: Number(taskForm.value.type),
      message: taskForm.value.message,
      start_time: taskForm.value.startTime
        ? Math.floor(+taskForm.value.startTime / 1000)
        : 0,
      end_time: taskForm.value.endTime
        ? Math.floor(+taskForm.value.endTime / 1000)
        : 0,
      interval: taskForm.value.interval || 0,
      remark: "",
    };

    const response = await client.createTask(account, taskData);

    if (response.code === 1) {
      message.success("创建任务成功");
      fetchTasks();
      Modal.success({
        title: "任务创建结果",
        content: response.reason || "任务创建成功",
        onOk: () => {
          addTaskModalVisible.value = false;
          // 重置表单
          taskForm.value = {
            phone: [],
            message: "",
            targets: [],
            targetIds: [],
            startTime: null,
            endTime: null,
            interval: null,
            type: 1,
          };
        },
      });
    } else {
      message.error(response.reason || "创建任务失败");
    }
  } catch (error) {
    console.error("创建任务失败:", error);
    message.error("表单验证失败或创建任务失败");
  } finally {
    confirmLoading.value = false;
  }
};


// 处理新增任务
const handleAddTaskID = async () => {
  console.log("handleAddTaskID");
  try {
    await addTaskFormRef.value?.validate();
    confirmLoading.value = true;

    // 直接使用选择的用户名，不需要再查找
    const targets = taskForm.value.targetIds.map(name => ({ name }));
 
    const taskData = {
      task_type:2,
      phones: taskForm.value.phone,
      targets: targets,
      msg_type: Number(taskForm.value.type),
      message: taskForm.value.message,
      start_time: taskForm.value.startTime
        ? Math.floor(+taskForm.value.startTime / 1000)
        : 0,
      end_time: taskForm.value.endTime
        ? Math.floor(+taskForm.value.endTime / 1000)
        : 0,
      interval: taskForm.value.interval || 0,
      remark: "",
    };

    const response = await client.createTask(account, taskData);

    if (response.code === 1) {
      message.success("创建任务成功");
      fetchTasks();
      Modal.success({
        title: "任务创建结果",
        content: response.reason || "任务创建成功",
        onOk: () => {
          addTaskModalVisible.value = false;
          // 重置表单
          taskForm.value = {
            phone: [],
            message: "",
            targets: [],
            targetIds: [],
            startTime: null,
            endTime: null,
            interval: null,
            type: 1,
          };
        },
      });
    } else {
      message.error(response.reason || "创建任务失败");
    }
  } catch (error) {
    console.error("创建任务失败:", error);
    message.error("表单验证失败或创建任务失败");
  } finally {
    confirmLoading.value = false;
  }
};



// 处理取消添加任务
const handleAddTaskCancel = () => {
  addTaskModalVisible.value = false;
  taskForm.value = {
    phone: [],
    message: "",
    targets: [],
    targetIds: [],
    startTime: null,
    endTime: null,
    interval: null,
    type: 1,
  };

  console.log("fasdfas");

};

// 转换发送者列表为 Select 组件需要的格式
const phoneOptions = computed(() => {
  return phoneList.value.map((phone) => ({
    value: phone,
    label: phone,
  }));
});

// 添加发送者选择处理函数
const handlePhoneChange = (value: string[]) => {
  console.log("选择的发送者:", value);
  taskForm.value.phone = value;
};

const searchText = ref("");
const searchId = ref("");
// 过滤接收者列表
const filteredTargets = computed(() => {
  if (!searchText.value) return targetsList.value;
  const search = searchText.value.toLowerCase();
  return targetsList.value.filter(
    (target) =>
      target.name.toLowerCase().includes(search) ||
      (target.nickname && target.nickname.toLowerCase().includes(search))
  );
});

const onSearch = (value: string) => {
  searchText.value = value;
};


// 过滤接收者列表
const filteredTargetIds = computed(() => {
  if (!searchId.value) return targetIdsList.value;
  const search = searchId.value.toLowerCase();
  return targetIdsList.value.filter(
    (target) =>
      target.name.toLowerCase().includes(search) ||
      (target.nickname && target.nickname.toLowerCase().includes(search))
  );
});

const onSearchID = (value: string) => {
  searchId.value = value;
};


const handleBatchSelect = () => {
  // 获取当前过滤后的列表
  const currentList = filteredTargets.value;
  var count = currentList.length;
  // 使用 name 而不是 id
  const newTargets = currentList
    .slice(0, count)
    .map((target) => target.name);

  // 更新选择
  taskForm.value.targets = newTargets;
};

const handleClearSelection = () => {
  // 清空选择
  taskForm.value.targets = [];
};


const handleBatchSelectId = () => {
  // 获取当前过滤后的列表
  const currentList = filteredTargetIds.value;
  var count = currentList.length;
  // 使用 name 而不是 id
  const newTargets = currentList
    .slice(0, count)
    .map((target) => target.name);

  // 更新选择
  taskForm.value.targetIds = newTargets;
};

const handleClearSelectionId = () => {
  // 清空选择
  taskForm.value.targetIds = [];
};



const getStatusColor = (status: number) => {
  switch (status) {
    case 1:
      return 'blue';    // 待执行
    case 2:
      return 'orange';  // 执行中
    case 3:
      return 'green';   // 执行完毕
    default:
      return 'default';
  }
};

const getStatusText = (status: number) => {
  switch (status) {
    case 1:
      return '待执行';
    case 2:
      return '执行中';
    case 3:
      return '执行完毕';
    default:
      return '未知状态';
  }
};

// 添加链接编辑对话框的状态
const linkModalVisible = ref(false);
const linkForm = reactive({
  text: '',
  url: ''
});

// 添加文本格式化方法
const formatText = {
  bold: () => {
    const textarea = document.querySelector('.task-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`*${selected}*`, start, end);
  },

  italic: () => {
    const textarea = document.querySelector('.task-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`_${selected}_`, start, end);
  },

  underline: () => {
    const textarea = document.querySelector('.task-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`__${selected}__`, start, end);
  },

  strikethrough: () => {
    const textarea = document.querySelector('.task-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`~${selected}~`, start, end);
  },

  code: () => {
    const textarea = document.querySelector('.task-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`\`${selected}\``, start, end);
  },

  codeblock: () => {
    const textarea = document.querySelector('.task-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`\`\`\`\n${selected}\n\`\`\``, start, end);
  },

  spoiler: () => {
    const textarea = document.querySelector('.task-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`||${selected}||`, start, end);
  },

  quote: () => {
    const textarea = document.querySelector('.task-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    const formatted = selected.split('\n').map(line => `> ${line}`).join('\n');
    insertText(formatted, start, end);
  },

  link: () => {
    const textarea = document.querySelector('.task-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const text = textarea.value;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    linkForm.text = text.substring(start, end);
    linkForm.url = '';
    
    const currentPos = { start, end };
    (textarea as any).savedPos = currentPos;
    
    linkModalVisible.value = true;
  }
};

// 辅助函数：插入文本
const insertText = (newText: string, start: number, end: number) => {
  const textarea = document.querySelector('.task-form-container textarea') as HTMLTextAreaElement;
  if (!textarea) return;
  
  const text = textarea.value;
  taskForm.value.message = text.substring(0, start) + newText + text.substring(end);
  
  textarea.focus();
  const newPosition = start + newText.length;
  textarea.setSelectionRange(newPosition, newPosition);
};

// 处理链接确认
const handleLinkConfirm = () => {
  const textarea = document.querySelector('.task-form-container textarea') as HTMLTextAreaElement;
  if (!textarea) return;
  
  const { start, end } = (textarea as any).savedPos || { start: 0, end: 0 };
  const linkMarkdown = `[${linkForm.text}](${linkForm.url})`;
  
  insertText(linkMarkdown, start, end);
  linkModalVisible.value = false;
};
</script>

<style scoped>
.task-manager {
  height: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 16px;
  border-radius: 8px;
  position: relative;
  /* 添加硬件加速 */
  transform: translateZ(0);
  will-change: transform;
}

.task-content {
  flex: 1;
  /* 使用 CSS transform 来避免重排 */
  transform: translateZ(0);
  will-change: transform;
}

.task-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  margin-bottom: 16px;
  background: #fafafa;
  border-radius: 4px;
}

.task-container {
  flex: 1;
  min-height: 0;
  overflow: auto;
  position: relative;
  padding: 0 16px;
}

.header-buttons {
  display: flex;
  gap: 8px;
}

.action-bar {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 12px 16px;
  background: #f8f9fa;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.delete-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  height: 32px;
}

:deep(.custom-table) {
  .ant-table {
    border-radius: 8px;
    overflow: hidden;
  }

  .ant-table-thead > tr > th {
    background: #f0f5ff;
    font-weight: 600;
    padding: 12px 16px;
  }

  .ant-table-tbody > tr > td {
    padding: 12px 16px;
  }

  .ant-table-tbody > tr:hover > td {
    background: #e6f4ff;
  }

  .ant-table-row {
    transition: all 0.3s ease;
  }

  .ant-tag {
    border-radius: 4px;
    padding: 2px 8px;
  }

  .ant-btn {
    border-radius: 4px;
  }
}

:deep(.ant-pagination) {
  margin: 16px 0;
  display: flex;
  justify-content: flex-end;
}

:deep(.ant-table-wrapper) {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
}

.task-form-container {
  display: flex;
  gap: 24px;
}

.form-left {
  flex: 1;
  min-width: 400px;
}

.form-right {
  flex: 1;
  min-width: 400px;
}

.targets-container {
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  height: 200px;
  display: flex;
  flex-direction: column;
}

.targets-header {
  padding: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.search-row {
  margin-bottom: 12px;
}

.targets-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
}

.batch-select {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.batch-select .ant-btn {
  font-size: 12px;
  height: 24px;
  padding: 0 8px;
}

.targets-count {
  color: #666;
  font-size: 12px;
}

.targets-list {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
}

.targets-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.target-item {
  margin: 0;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.target-item:hover {
  background-color: #f5f5f5;
}

.target-info {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.target-name {
  font-weight: 500;
}

.target-nickname {
  color: #666;
  font-size: 12px;
}

:deep(.ant-modal-body) {
  max-height: 80vh;
  overflow-y: auto;
}

.format-toolbar {
  margin-bottom: 8px;
  padding: 8px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background: #fafafa;
}

.format-toolbar .ant-btn {
  padding: 0 8px;
  font-size: 12px;
  height: 24px;
  line-height: 22px;
  margin-right: 4px;
}

.format-toolbar .ant-btn:hover {
  color: #1890ff;
  border-color: #1890ff;
}

.task-manager-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 1000;
  padding: 20px;
}


</style>
